import React, { useEffect, useState } from 'react';
import {
    Box,
    Dialog,
    Typography,
    Button,
    Tabs,
    Tab,
    FormControlLabel,
    Switch,
} from '@mui/material';

const RegionTabButton = ({ value, tab, tabValue, onClick }) => {
    const [name, setName] = useState('');

    return (
        <Box
            style={{
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                display: 'flex',
                justifyContent: 'center',
                padding: 6,
                paddingTop: 12,
                paddingBottom: 12,
                cursor: 'pointer',
                backgroundColor: tab === tabValue ? '#ebf4fa' : '#ff',
            }}
            onClick={() => {
                onClick(tab);
            }}
        >
            <Typography
                variant="body2"
                style={{
                    color: '#035dab',
                    fontWeight: tab === tabValue ? 600 : 400,
                }}
            >
                {value}
            </Typography>
        </Box>
    );
};

export default RegionTabButton;
